<template>
  <div id="app">
    <top-navbar/>
    <router-view/>
  </div>
</template>

<script>
import TopNavbar from './components/TopNavbar'
import {mapActions} from 'vuex'
export default {
  methods: {
    ...mapActions(['getNotificationsCollection']),
    listen () {
      const echo = window.Echo
      // expense
      echo.channel('notifyChannel')
      .listen('Notify', () => {
        this.getNotificationsCollection()
      })
    }
  },
  created () {
    this.listen()
  },
  components: {
    TopNavbar
  }
}
</script>

<style lang="scss">
@import "../sass/main";
</style>
